<template>
  <div class="all">
    <el-form label-width="130px"
             :model="dataForm"
             :rules="rules"
             ref="ruleForm">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="工商营业执照注册号/统一社会信用代码"
                        label-width="270px"
                        prop="socialCreditCode">
            <el-input v-model="dataForm.socialCreditCode"
                      placeholder="工商营业执照注册号/统一社会信用代码"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="开户银行">
            <el-select v-model="dataForm.ourBank"
                       style="width: 100%;"
                       placeholder="开户银行">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="账户名称">
            <el-input v-model="dataForm.accountName"
                      placeholder="账户名称"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="银行账号">
            <el-input v-model="dataForm.bankAccount"
                      placeholder="银行账号"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="税务登记号">
            <el-input v-model="dataForm.taxRegistrationCode"
                      placeholder="税务登记号"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="账期">
            <el-input v-model="dataForm.accountPeriod"
                      placeholder="账期"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="结算方式">
            <el-select v-model="dataForm.settlement"
                       style="width: 100%;"
                       placeholder="结算方式">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="发运方式">
            <el-select v-model="dataForm.shipmentMode"
                       style="width: 100%;"
                       placeholder="发运方式">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="付款条件">
            <el-input v-model="dataForm.paymentTerms"
                      placeholder="付款条件"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="营业执照">
            <el-image style="width: 200px; height: 130px"
                      :src="url"
                      :preview-src-list="srcList">
            </el-image>
            <el-upload class="upload-demo"
                       :action="action"
                       :with-credentials="true"
                       :headers="myHeaders"
                       :on-change="handleChange"
                       :before-upload="beforeUpload"
                       :file-list="fileList">
              <el-button size="small"
                         type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法人身份证">
            <div class="demo-image__preview">
              <el-image style="width: 200px; height: 130px"
                        :src="url"
                        :preview-src-list="srcList">
              </el-image>
              <el-upload class="upload-demo"
                         :action="action"
                         :with-credentials="true"
                         :headers="myHeaders"
                         :on-change="handleChange"
                         :before-upload="beforeUpload"
                         :file-list="fileList">
                <el-button size="small"
                           type="primary">点击上传</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="客户标签">
            <el-tag :key="tag"
                    v-for="tag in dynamicTags"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)">
              {{tag}}
            </el-tag>
            <el-input class="input-new-tag"
                      v-if="inputVisible"
                      v-model="inputValue"
                      ref="saveTagInput"
                      size="small"
                      @keyup.enter.native="handleInputConfirm"
                      @blur="handleInputConfirm">
            </el-input>
            <el-button v-else
                       class="button-new-tag"
                       size="small"
                       @click="showInput">+ 添加</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input type="textarea"
                      :rows="2"
                      placeholder="备注"
                      v-model="dataForm.businessInfoRemarks">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
      },
      rules: {
        socialCreditCode: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ]
      },
      options: [
        {
          value: '选项1',
          label: '北京烤鸭'
        },
        {
          value: '选项2',
          label: '北京烤鸭'
        },
        {
          value: '选项3',
          label: '北京烤鸭'
        },
        {
          value: '选项4',
          label: '北京烤鸭'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ],
      fileList: [],
      action: '',
      myHeaders: {},
      dynamicTags: ['标签一', '标签二', '标签三'],
      inputVisible: false,
      inputValue: ''
    }
  },
  methods: {
    save () {
      let flag = null
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          flag = true
        } else {
          flag = false
        }
      })
      return flag
    },
    handleChange () {

    },
    beforeUpload () {

    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  },
  components: {
  }
}
</script>
<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
